export const featuredClassesHeader = 'Featured Group Courses'
